import CollectionShelfv2 from './CollectionShelfV2'

export default CollectionShelfv2
